"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactChartjs = require("react-chartjs-2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// -------------- Bar Graph Impelementation -------------------- 
function BarGraph(data) {
  const Labels = data.data.map(lan => lan.label);
  const dataVal = data.data.map(val => val.value);
  const colorr = data.data.map(col => col.color);
  console.log("Data from app ", data.data);
  const graphData = {
    labels: Labels,
    datasets: [{
      label: 'Data',
      backgroundColor: colorr,
      data: dataVal
    }]
  };
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: data.backstyle
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
    data: graphData,
    style: data.style,
    width: data.style.width,
    height: data.style.height,
    options: graphOptions
  }));
}
var _default = exports.default = BarGraph;